import { render, staticRenderFns } from "./conciseCard.vue?vue&type=template&id=0f1c0197&scoped=true&"
import script from "./conciseCard.vue?vue&type=script&lang=ts&"
export * from "./conciseCard.vue?vue&type=script&lang=ts&"
import style0 from "./conciseCard.vue?vue&type=style&index=0&id=0f1c0197&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c0197",
  null
  
)

export default component.exports